import axios from 'axios';
import React, { useEffect } from 'react'
import API from '../../../../utils/API';
import { toast } from 'react-toastify';

export default function Slot() {
    const [allData, setAllData] = React.useState({});

    const batchSize = 5000;

    const getAllStudents = async () => {
        try {
            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.GET_PAID_SPEAKER, {});
            setAllData(data?.data);
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    useEffect(() => {
        getAllStudents();
    }, []);

    return (
        <div className='text-center mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 bg-[#F9FAFB] md:py-[50px] lg:py-[70px]' id='slot'>
            <p className='text-[28px] md:text-[40px] lg:text-[52px] font-bold text-center'>
                March Slots Bookings Open Now
            </p>
            <div className="mt-[40px]">
                <p className="text-[24px] md:text-[32px] lg:text-[44px] font-bold text-[#101828] text-center"> 5000 Slots - Just Opened </p>
                <div className="md:w-11/12 mx-auto mt-[10px] md:mt-[20px]">
                    <div className="flex items-center justify-center gap-[20px] md:gap-[34px] flex-wrap mt-[40px]">
                        <div className='w-[200px] h-[110px] rounded-[20px] border border-[#D34F4F] bg-[#F7EEEE] flex flex-col justify-center items-center text-[18px] text-[#000] cursor-auto'>
                            <p className='font-bold'>February Slots</p>
                            <p className='font-normal'>Booking Closed</p>
                        </div>
                        <div className='w-[200px] h-[110px] rounded-[20px] border border-[#4FD387] bg-[#EEF7F3] flex flex-col justify-center items-center text-[18px] text-[#000] cursor-pointer' onClick={() => (window.location.href = "/surge-speakers/form")}>
                            <p className='font-bold'>March Slots</p>
                            <p className='font-normal'>Booking Open</p>
                            <p className='mt-[5px] text-[12px] font-bold'>Available Only {batchSize - allData?.length}</p>
                        </div>
                        <div className='w-[200px] h-[110px] rounded-[20px] border border-[#4FA3D3] bg-[#EEF6F7] flex flex-col justify-center items-center text-[18px] text-[#000] cursor-auto'>
                            <p className='font-bold'>April Slots</p>
                            <p className='font-normal'>Will be Open <br /> Shortly</p>
                        </div>
                    </div>
                </div>
                <div className='mt-[20px] md:mt-[30px] xl:mt-[54px] w-full grid md:flex md:justify-center md:items-center gap-[20px]'>
                    <button
                        className='bg-[#34C759] w-[200px] mx-auto md:w-[365px] h-[40px] md:h-[55px] lg:h-[82px] rounded-[10px] md:rounded-[22px] text-[#FFF] text-[14px] md:text-[18px] lg:text-[22px] font-semibold'
                        onClick={() => (window.location.href = "/surge-speakers/form")}
                    >
                        Speakers Booking Details
                    </button>
                </div>
            </div>
        </div>
    )
}
